import i18n from "i18next";
import * as Permissions from "../../supportFunctions/Permissions";

export interface NavItemsType {
  label: string;
  icon?: string;
  path: string;
  permission: string[];
  flag?: string;
}

export const navItems = (): NavItemsType[] => {
  return [
    {
      label: i18n.t("universal_all_roles"),
      path: "/role-management/all-roles",
      permission: [Permissions.canEditRole],
    },
    {
      label: i18n.t("universal_ehs_roles"),
      path: "/role-management/ehs-roles",
      permission: [Permissions.canManageEhsRoles],
      flag: "showEHSRoles",
    },
    {
      label: i18n.t("universal_assignment_by_location"),
      path: "/role-management/location-roles",
      permission: [],
    },
  ];
};
